import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/resources/$id/linked-to")({
  staticData: {
    title: "linkedTo.title",
  },
});
